var _metadata, _defs, _sodipodiNamedview;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhillipsconnectLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    id: "svg2",
    xmlSpace: "preserve",
    width: 200,
    height: 40,
    viewBox: "0 0 783.97333 88.080002",
    sodipodiDocname: "Phillips Connect Logo (Black).eps",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata8"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfResource: "http://purl.org/dc/dcmitype/StillImage"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    objecttolerance: 10,
    gridtolerance: 10,
    guidetolerance: 10,
    inkscapePageopacity: 0,
    inkscapePageshadow: 2,
    "inkscapeWindow-width": 640,
    "inkscapeWindow-height": 480,
    id: "namedview4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g10",
    inkscapeGroupmode: "layer",
    inkscapeLabel: "ink_ext_XXXXXX",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,88.08)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12",
    transform: "scale(0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 5064.4,540.473 h -249.79 c -14.27,0 -25.83,-11.567 -25.83,-25.832 0,-14.27 11.56,-25.832 25.83,-25.832 h 249.79 c 14.27,0 25.83,11.562 25.83,25.832 0,14.265 -11.56,25.832 -25.83,25.832",
    style: {
      fill: "#0d0d0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5064.4,358.777 h -249.79 c -14.27,0 -25.83,-11.562 -25.83,-25.832 0,-14.265 11.56,-25.828 25.83,-25.828 h 249.79 c 14.27,0 25.83,11.563 25.83,25.828 0,14.27 -11.56,25.832 -25.83,25.832",
    style: {
      fill: "#0d0d0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5064.4,176.789 h -249.79 c -14.27,0 -25.83,-11.566 -25.83,-25.832 0,-14.266 11.56,-25.832 25.83,-25.832 h 249.79 c 14.27,0 25.83,11.566 25.83,25.832 0,14.266 -11.56,25.832 -25.83,25.832",
    style: {
      fill: "#0d0d0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5854,540.473 h -279.75 c -14.27,0 -25.83,-11.567 -25.83,-25.832 0,-14.27 11.56,-25.832 25.83,-25.832 h 114 V 151.422 c 0,-14.266 11.56,-25.828 25.83,-25.828 14.26,0 25.83,11.562 25.83,25.828 V 488.809 H 5854 c 14.26,0 25.83,11.562 25.83,25.832 0,14.265 -11.57,25.832 -25.83,25.832",
    style: {
      fill: "#0d0d0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5456.3,222.258 c -29.5,-29.426 -68.69,-45.625 -110.36,-45.625 -86.18,0 -156.29,70.109 -156.29,156.285 0,86.18 70.11,156.289 156.29,156.289 41.47,0 80.54,-16.078 110,-45.262 10.12,-10.05 26.48,-9.972 36.52,0.168 10.05,10.137 9.97,26.489 -0.17,36.528 -39.19,38.843 -91.17,60.226 -146.35,60.226 -114.67,0 -207.95,-93.281 -207.95,-207.949 0,-114.664 93.28,-207.949 207.95,-207.949 55.44,0 107.59,21.558 146.84,60.707 10.1,10.07 10.13,26.429 0.05,36.531 -10.07,10.106 -26.43,10.121 -36.53,0.051",
    style: {
      fill: "#0d0d0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3491.38,222.258 c -29.5,-29.426 -68.69,-45.625 -110.36,-45.625 -86.18,0 -156.29,70.109 -156.29,156.285 0,86.18 70.11,156.289 156.29,156.289 41.47,0 80.53,-16.078 109.99,-45.266 10.14,-10.043 26.49,-9.961 36.53,0.172 10.04,10.137 9.97,26.489 -0.17,36.532 -39.2,38.839 -91.17,60.222 -146.35,60.222 -114.67,0 -207.95,-93.281 -207.95,-207.949 0,-114.664 93.28,-207.949 207.95,-207.949 55.44,0 107.59,21.558 146.84,60.707 10.1,10.078 10.12,26.429 0.05,36.531 -10.07,10.102 -26.43,10.121 -36.53,0.051",
    style: {
      fill: "#0d0d0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3927.71,306.371 c -5.46,-31.976 -20.57,-61.062 -43.69,-84.113 -29.5,-29.426 -68.69,-45.625 -110.35,-45.625 -86.18,0 -156.29,70.109 -156.29,156.285 0,86.18 70.11,156.289 156.29,156.289 41.46,0 80.53,-16.078 109.99,-45.266 19.94,-19.753 34.2,-44.461 41.24,-71.445 3.35,-12.848 5.05,-26.164 5.05,-39.578 0,-8.906 -0.75,-17.844 -2.24,-26.547 z m -7.69,174.274 c -39.2,38.839 -91.18,60.222 -146.35,60.222 -114.67,0 -207.95,-93.281 -207.95,-207.949 0,-114.664 93.28,-207.949 207.95,-207.949 55.44,0 107.58,21.558 146.83,60.707 30.75,30.66 50.85,69.39 58.14,111.996 1.97,11.574 2.97,23.43 2.97,35.246 0,17.816 -2.26,35.52 -6.72,52.617 -9.37,35.949 -28.35,68.836 -54.87,95.11",
    style: {
      fill: "#0d0d0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4715.16,540.473 c -14.26,0 -25.83,-11.567 -25.83,-25.832 v -287.59 l -234.64,303.39 c -6.75,8.735 -18.32,12.215 -28.78,8.645 -10.45,-3.57 -17.48,-13.398 -17.48,-24.445 V 151.422 c 0,-14.266 11.56,-25.828 25.83,-25.828 14.27,0 25.83,11.562 25.83,25.828 v 287.59 l 234.64,-303.391 c 4.99,-6.445 12.59,-10.027 20.44,-10.027 2.78,0 5.6,0.445 8.34,1.383 10.46,3.57 17.48,13.398 17.48,24.445 v 363.219 c 0,14.265 -11.56,25.832 -25.83,25.832",
    style: {
      fill: "#0d0d0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4335.09,540.473 c -14.27,0 -25.83,-11.567 -25.83,-25.832 v -287.59 l -234.64,303.39 c -6.76,8.735 -18.32,12.215 -28.79,8.645 -10.45,-3.57 -17.48,-13.398 -17.48,-24.445 V 151.422 c 0,-14.266 11.57,-25.828 25.83,-25.828 14.27,0 25.83,11.562 25.83,25.828 v 287.59 l 234.64,-303.391 c 4.99,-6.445 12.6,-10.027 20.44,-10.027 2.79,0 5.6,0.445 8.35,1.383 10.45,3.57 17.48,13.398 17.48,24.445 v 363.219 c 0,14.265 -11.57,25.832 -25.83,25.832",
    style: {
      fill: "#0d0d0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 162.273,497.277 h 46.071 c 34.383,0 86.644,-7.711 86.644,-65.101 0,-53.106 -27.511,-71.957 -65.328,-71.957 h -67.387 z m 0,-280.968 h 81.829 c 94.238,0 153.777,36.832 183.281,100.238 V 24.4375 H 576.781 V 240.566 H 785.375 V 24.4375 H 934.773 V 641.273 H 785.375 V 402.563 H 576.781 v 238.71 H 427.383 v -99.664 c -30.621,62.7 -93.031,99.571 -188.785,99.571 H 0 V 24.4375 H 162.273 V 216.309",
    style: {
      fill: "#0d0d0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1130.22,642.941 H 972.871 V 24.4375 H 1130.22 V 642.941",
    style: {
      fill: "#0d0d0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1828.69,642.941 H 1671.34 V 24.4375 h 157.35 V 642.941",
    style: {
      fill: "#0d0d0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1633.29,168.563 H 1323.57 V 642.941 H 1166.21 V 24.4375 h 467.08 V 168.563",
    style: {
      fill: "#0d0d0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1632.25,334.559 H 1509.53 V 642.941 H 1348.35 V 198.066 h 283.9 v 136.493",
    style: {
      fill: "#0d0d0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2026.55,497.277 h 46.07 c 34.38,0 86.63,-7.711 86.63,-65.101 0,-53.106 -27.5,-71.957 -65.32,-71.957 h -67.38 z m 0,-280.968 h 81.82 c 121.81,0 185.66,61.515 201.55,162.464 55.76,-115.218 237.56,-84.765 237.56,-184.25 0,-28.921 -23.78,-52.707 -62.64,-52.707 -15.15,0 -33.53,12.735 -46.04,22.938 -13.17,10.203 -22.4,26.367 -25.69,54.203 h -129.8 c 3.8,-134.25 66.67,-201.8086 210.14,-203.0507 103.71,-0.8907 212.96,57.4453 212.45,199.4607 -0.72,199.914 -249.82,150.567 -249.82,261.492 0,22.114 15.15,44.411 49.41,44.411 15.15,0 28.98,-5.313 40.18,-12.969 11.2,-7.645 19.76,-28.039 22.4,-41.668 h 134.2 c -1.66,109.066 -71.14,186.265 -202.89,186.265 -98.32,0 -174.85,-45.07 -198.13,-134.632 -25.84,76.828 -91.27,122.914 -198.38,122.914 h -238.6 V 24.4375 h 162.28 V 216.309",
    style: {
      fill: "#0d0d0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2922.35,660.559 V 0 h 45.84 v 660.559 h -45.84",
    style: {
      fill: "#0d0d0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path44"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhillipsconnectLogo);
export default __webpack_public_path__ + "static/media/phillipsconnect-logo.ee29a83bfcfc1644ab85d9f698d1549a.svg";
export { ForwardRef as ReactComponent };